import React, { useId, cloneElement } from 'react';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
import { StyledExtendedSelectionGroup, StyledFormMessage, StyledInner } from './index.styles.js';
import {} from '../extended-selection/index.js';
export const ExtendedSelectionGroup = ({ className, margin, disabled, children, hint, invalid, ...rest }) => {
    const isInvalid = invalid && !disabled;
    const id = useId();
    const hintId = `${id}--hint`;
    const ariaDescribedByProp = pickA11yProps(rest)['aria-describedby'];
    const ariaDescribedBy = hint || ariaDescribedByProp
        ? [
            hint ? hintId : undefined,
            ariaDescribedByProp ? ariaDescribedByProp : undefined
        ]
            .join(' ')
            .trim()
        : undefined;
    const modifiedChildren = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return cloneElement(child, {
                disabled: child.props.disabled ?? disabled,
                invalid: child.props.invalid ?? isInvalid
            });
        }
        return null;
    });
    return (React.createElement(StyledExtendedSelectionGroup, { className: className, margin: margin, ...pickA11yProps(rest), ...pickDataProps(rest), "aria-describedby": ariaDescribedBy },
        React.createElement(StyledInner, null, modifiedChildren),
        hint && (React.createElement(StyledFormMessage, { id: hintId, variant: isInvalid ? 'error' : 'hint', text: hint }))));
};
//# sourceMappingURL=index.js.map